import { render, staticRenderFns } from "./InvoiceDashboard.vue?vue&type=template&id=9904d336&"
import script from "./InvoiceDashboard.vue?vue&type=script&lang=js&"
export * from "./InvoiceDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports